module.exports = __webpack_public_path__ + "static/media/frecuentDestination.8a7e12dd.svg";